import { ADD_FUTURE_SUGGESTION, ADD_PARAMATERS, ADD_REMARK, ADD_SUGGESTION, ADD_TREATMENT, DATE_APPOINTMENT, DELETE_FUTURE_SUGGESTION, DELETE_PARAMATERS, DELETE_REMARK, DELETE_SUGGESTION, DELETE_TREATMENT, DOCTOR_ALL_APPOINTMENT, GET_DATE_APPOINTMENT, GET_DOCTOR_APPOINTMENT, GET_FUTURE_SUGGESTION, GET_PARAMATERS, GET_REMARK, GET_TREATMENT, MEDICINE_PACKAGE, MEDICINE_PRINT, PATIENT_CALL_LOG, UPDATE_DATE_APPOINTMENT, UPDATE_FUTURE_SUGGESTION, UPDATE_PARAMATERS, UPDATE_REMARK, UPDATE_SUGGESTION, UPDATE_TREATMENT, VIEW_ALL_SUGGESTION, VIEW_SUGGESTION_BY_ID } from "../actions/Doctor.action";

const initialState = {
    doctorAllAppointment: '',
    addSuggestion: '',
    viewAllSuggestion: '',
    viewSuggestionById: '',
    deleteSuggestion: '',
    updateSuggestion: '',
    addTreatment: '',
    getTreatment: '',
    deleteTreatment: '',
    updateTreatment: '',
    addParamaters: '',
    getParamaters: '',
    updateParamaters: '',
    deleteParamaters: '',
    addFutureSuggestion: '',
    getFutureSuggestion: '',
    updateFutureSuggestion: '',
    deleteFutureSuggestion: '',
    addRemark: '',
    getRemark: '',
    updateRemark: '',
    deleteRemark: '',
    medicinePrint: '',
    patientCallLog: '',
    medicinePackage: '',
    dateAppointment: '',
    getDateAppointment: '',
    updateDateAppointment: '',
    getDoctorAppointment: ''
}

const doctorReducer = (state = initialState, action) => {
    switch (action.type) {
        case DOCTOR_ALL_APPOINTMENT:
            return { ...state, doctorAllAppointment: action.payload };
        case ADD_SUGGESTION:
            return { ...state, addSuggestion: action.payload };
        case VIEW_ALL_SUGGESTION:
            return { ...state, viewAllSuggestion: action.payload };
        case VIEW_SUGGESTION_BY_ID:
            return { ...state, viewSuggestionById: action.payload };
        case DELETE_SUGGESTION:
            return { ...state, deleteSuggestion: action.payload };
        case UPDATE_SUGGESTION:
            return { ...state, updateSuggestion: action.payload };
        case ADD_TREATMENT:
            return { ...state, addTreatment: action.payload };
        case GET_TREATMENT:
            return { ...state, getTreatment: action.payload };
        case DELETE_TREATMENT:
            return { ...state, deleteTreatment: action.payload };
        case UPDATE_TREATMENT:
            return { ...state, updateTreatment: action.payload };
        case ADD_PARAMATERS:
            return { ...state, addParamaters: action.payload };
        case GET_PARAMATERS:
            return { ...state, getParamaters: action.payload };
        case DELETE_PARAMATERS:
            return { ...state, deleteParamaters: action.payload };
        case UPDATE_PARAMATERS:
            return { ...state, updateParamaters: action.payload };
        case ADD_FUTURE_SUGGESTION:
            return { ...state, addFutureSuggestion: action.payload };
        case GET_FUTURE_SUGGESTION:
            return { ...state, getFutureSuggestion: action.payload };
        case DELETE_FUTURE_SUGGESTION:
            return { ...state, deleteFutureSuggestion: action.payload };
        case UPDATE_FUTURE_SUGGESTION:
            return { ...state, updateFutureSuggestion: action.payload };
        case ADD_REMARK:
            return { ...state, addRemark: action.payload };
        case GET_REMARK:
            return { ...state, getRemark: action.payload };
        case DELETE_REMARK:
            return { ...state, deleteRemark: action.payload };
        case UPDATE_REMARK:
            return { ...state, updateRemark: action.payload };
        case MEDICINE_PRINT:
            return { ...state, medicinePrint: action.payload };
        case PATIENT_CALL_LOG:
            return { ...state, patientCallLog: action.payload };
        case MEDICINE_PACKAGE:
            return { ...state, medicinePackage: action.payload };
        case DATE_APPOINTMENT:
            return { ...state, dateAppointment: action.payload };
        case GET_DATE_APPOINTMENT:
            return { ...state, getDateAppointment: action.payload };
        case UPDATE_DATE_APPOINTMENT:
            return { ...state, updateDateAppointment: action.payload };
        case GET_DOCTOR_APPOINTMENT:
            return { ...state, getDoctorAppointment: action.payload };
        default:
            return state;
    }
}

export default doctorReducer;